/* Swedish translations for custom AR control inserted by theme/app scripts. */
(()=> {
 if(document.documentElement.lang.toLowerCase().split('-')[0]!=='sv')return;
 const dict={
  'Katso matto huoneessasi':'Se mattan i ditt rum',
  'Valmistellaan AR:ää…':'Förbereder AR…',
  'AR on valmis. Napauta painiketta uudelleen.':'AR är redo. Tryck på knappen igen.',
  'Näytä viivakoodi':'Visa streckkod'
 };
 function fix(node){
  if(!node || !(node instanceof Element))return;
  const match='button, a, span, strong, [class*="ar-"], [data-ar]';
  const els=[];
  if(node.matches(match))els.push(node);
  node.querySelectorAll(match).forEach(e=>els.push(e));
  for(const el of els){
   for(const child of el.childNodes){
    if(child.nodeType!==3)continue;
    const old=child.textContent||'';
    const trimmed=old.trim();
    if(!Object.hasOwn(dict,trimmed))continue;
    child.textContent=old.replace(trimmed,dict[trimmed]);
   }
  }
 }
 let scheduled=false;
 function queue(){
  if(scheduled)return;
  scheduled=true;
  requestAnimationFrame(()=>{scheduled=false;fix(document.body)});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{
  queue();new MutationObserver(queue).observe(document.body,{childList:true,subtree:true});
 },{once:true});
 else {queue();new MutationObserver(queue).observe(document.body,{childList:true,subtree:true});}
})();